import { render, staticRenderFns } from "./departmentandclasses.vue?vue&type=template&id=13baca88&scoped=true&"
import script from "./departmentandclasses.vue?vue&type=script&lang=js&"
export * from "./departmentandclasses.vue?vue&type=script&lang=js&"
import style0 from "./departmentandclasses.vue?vue&type=style&index=0&id=13baca88&lang=scss&scoped=true&"
import style1 from "./departmentandclasses.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./departmentandclasses.vue?vue&type=style&index=2&id=13baca88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13baca88",
  null
  
)

export default component.exports